// React imports
import React, { useState, useEffect } from 'react';

// UI – style imports
import { WithStyles, withStyles } from '@material-ui/core';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Description.style';
import dashInicio from 'images/dash-inicio.png';

function Description(props: WithStyles<typeof styles>) {
    const { classes } = props;
    const [showSafariMargin, setMargin] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const { userAgent } = window.navigator;
            setMargin(/^((?!chrome|android).)*safari/i.test(userAgent));
        }
    }, []);

    return (
        <Box className={clsx(classes.root, showSafariMargin && 'safari-margin')}>
            <Box id="phoneCard">
                <img src={dashInicio} alt="Tarjeta y app Cuenca" />
            </Box>

            <Box className={classes.textContainer}>
                <Box className={classes.titleContainer}>
                    <p id="topTitle">La cuenta que</p>
                    <div id="title">
                        <p id="top">NOSOTROS</p>
                        <p id="bot">USAMOS</p>
                    </div>
                </Box>

                <p id="text">
                    Abrir tu cuenta en Cuenca es rápido y sencillo. En minutos puedes empezar a enviar y recibir
                    transferencias vía SPEI usando tu CLABE interbancaria. Transfiere a otros bancos cuando quieras. Tu
                    dinero está disponible para ti los 365 días del año, las 24 horas del día. Y sí: funciona en todo
                    México.
                </p>
                <p id="text">
                    En Cuenca creemos que los servicios financieros son para todxs. Usamos tecnología innovadora para
                    construir un mejor futuro financiero en México. Creamos la cuenta que siempre quisimos tener:
                    simple, accesible y hecha para ti.
                </p>
            </Box>
        </Box>
    );
}

export default withStyles(styles)(Description);
